// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ContainerEnvironmentIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12.06 22h-.29l-7.91-4.23a1 1 0 0 1-.26-.24 1 1 0 0 1-.1-.35V6.67l.08-.19a1 1 0 0 1 .16-.14l.12-.1h.05l7.82-4.17a.6.6 0 0 1 .57 0l7.91 4.14q.06.03.11.1a.6.6 0 0 1 .18.47v10.35a1 1 0 0 1-.1.35q-.1.16-.26.25l-7.78 4.18h-.15zm.64-10.63v8.86l6.64-3.47v-8.8zm-7.9 5.39 6.62 3.47v-8.86L4.8 7.97zm.78-10 6.48 3.45 6.52-3.44-6.52-3.35z"
    />
  </svg>,
  "ContainerEnvironment",
);
export default ContainerEnvironmentIcon;
